import type { DestroyOptions } from 'pixi.js';
import { Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import { getLocalizedValue } from '@softgames/localization';
import type { IAPProduct } from '../../app/iap/types';
import { ShopCoinOfferLayout } from '../../../layouts/mainMenu/shop/ShopCoinOfferLayout';
import { InventoryItem } from '../../app/resources/types';

export enum CoinOfferSpecialLabel {
  Popular = 'Popular',
  BestValue = 'BestValue',
}

export class ShopCoinOfferView extends Container {
  public readonly onOfferClicked = new Signal<(product: IAPProduct) => void>();

  private readonly offerLayout = new ShopCoinOfferLayout();

  constructor(product: IAPProduct) {
    super();
    this.init(product);
  }

  private init(product: IAPProduct): void {
    const { root, icon, coinRewardText, priceLabelText } = this.offerLayout;

    root.props({
      parent: this,
    });

    icon.props(product.data?.offerSimpleView?.icon ?? {});
    coinRewardText.text = product.rewards[InventoryItem.Coin] ?? 0;
    coinRewardText.text = getLocalizedValue(product.rewards[InventoryItem.Coin] ?? 0);
    priceLabelText.text = product.priceLabel ?? '';

    root.onpointertap = (): void => {
      this.onOfferClicked.emit(product);
    };
  }

  public destroy(options?: DestroyOptions): void {
    this.onOfferClicked.disconnectAll();
    this.offerLayout.root.onpointertap = null;
    super.destroy(options);
  }
}
